namespace JupitersChoice {
    export class BaseGameJupiter extends Sapphire.SpineAnimation {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('GameStage') _gameStage: Sapphire.GameStage;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;

        private _animations: any;
        private _isAnticipating: boolean;
        private _anticipationInterval: number;
        private _anticipationOnComplete: Function;
        private _introComplete: boolean;

        constructor() {
            super();

            this._animations = {
                "landscape": {
                    anticipationIntro: 'antic_intro',
                    anticipationLoop: 'antic_idle'
                },
                "portrait": {
                    anticipationIntro: 'portrait_antic2_intro',
                    anticipationLoop: 'portrait_antic2_idle'
                }
            }
        }

        construct(data: any): void {
            super.construct(data, this._assetCache);
        }

        set anticipationOnComplete(callback: Function) {
            this._anticipationOnComplete = callback;
        }

        startAnticipation(newOrientation: string): void {
            this._isAnticipating = true;
            this._introComplete = false;

            if (this._anticipationInterval) {
                clearInterval(this._anticipationInterval);
            }

            this.showIntroAnticipation(newOrientation)
        }

        protected showIntroAnticipation(newOrientation: string) {
            this.changeAnimation(
                this._animations[newOrientation].anticipationIntro,
                true,
                false,
                () => this.onIntroAnticipationComplete(newOrientation)
            );
        }

        protected onIntroAnticipationComplete(newOrientation: string) {
            this._introComplete = true;
            this.changeAnimation(this._animations[newOrientation].anticipationLoop, true, true);

            this._anticipationInterval = setInterval(() => {
                if (this._anticipationOnComplete) {
                    clearInterval(this._anticipationInterval);
                    this._anticipationOnComplete();
                }
            }, 4000);
        }

        stopAnticipation(): void {
            this._isAnticipating = false;
        }

        setOrientation(newOrientation: string): void {
            super.setOrientation(newOrientation);

            if (this._isAnticipating) {
                if (!this._introComplete) {
                    this.showIntroAnticipation(newOrientation);
                } else {
                    this.changeAnimation(this._animations[newOrientation].anticipationLoop, true, true);
                }
            }
        }
    }
}
